import { Button, styled} from '@mui/material';

export const MaskButton = styled(Button)`
  background-color: rgb(4, 169, 111);
  :hover {
    background-color: rgb(2, 98, 65);
  }
`;